export default __webpack_public_path__ + "static/media/resources-optimization-costa-rica.eaf71bc2.png";